import { LoadingCircleAnimation } from '~/assets';
import { Button, Typography } from '~/components';
import { Animation, Icon, getTheme, pxToRem, styled } from '~/modules';

const textMain = getTheme('text.main');
const mdSpacing = getTheme('spacing.md');

export const IconComponent = styled(Icon).attrs({
  fontSize: pxToRem(60),
})`
  color: ${textMain};
  opacity: 0.5;
  margin-bottom: 50%;
`;

export const Title = styled(Typography).attrs({
  variant: 'xxl',
})`
  font-weight: 600;
`;
export const Description = styled(Typography).attrs({
  variant: 'md',
})`
  line-height: 150%;
`;

export const LoadingIndicator = styled(Animation).attrs({
  options: {
    animationData: LoadingCircleAnimation,
  },
  width: pxToRem(120),
  height: pxToRem(120),
  speed: 1.5,
})`
  margin-bottom: ${mdSpacing}px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40%;
  flex: 1;
  gap: ${mdSpacing}px;
`;

export const ButtonComponent = styled(Button)`
  width: 100%;
  margin: auto;
`;
